module.exports = __webpack_public_path__ + "img/pr-2.9a5fc983.png";